import Vue from 'vue'
import Router from 'vue-router'
// import formIndex from '../views/currency/formIndex'
// import codePage from '../views/currency/codePage'
// import List from '../views/currency/list'
import prisonFormIndex from '../views/prison/prisonFormIndex'
import prisonCodePage from '../views/prison/prisonCodePage'
import prisonList from '../views/prison/prisonList'
import newFormIndex from '../views/newForm/formIndex'
import newCodePage from '../views/newForm/codePage'
import newList from '../views/newForm/list'
import puchaFormIndex from '../views/pucha/puchaFormIndex'
import puchaCodePage from '../views/pucha/puchaCodePage'
import puchaList from '../views/pucha/puchaList'
import nkdForm from "../views/nkd/nkdForm";
import nkdList from "../views/nkd/nkdList";
import sjzFormIndex from "../views/sjz/sjzFormIndex";
import sjzCodePage from "../views/sjz/sjzCodePage";
import sjzList from "../views/sjz/sjzList";
import test from "../views/test/test";

const puchaEngForm = () => import("../views/pucha/puchaEngForm")

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '',
    //   redirect: '/zhongdian'
    // },

    // 已废弃
    // {
    //   path: '/form',
    //   name: 'formIndex',
    //   component: formIndex
    // },
    // {
    //   path: '/code',
    //   name: 'codePage',
    //   component: codePage
    // },
    // {
    //   path: '/list',
    //   name: 'List',
    //   component: List
    // },

    // 监狱
    {
      path: '/prison',
      name: 'prisonFormIndex',
      component: prisonFormIndex
    },
    {
      path: '/prison_code',
      name: 'prisonCodePage',
      component: prisonCodePage
    },
    {
      path: '/prison_list',
      name: 'prisonList',
      component: prisonList
    },

    // 重点
    {
      path: '/zhongdian',
      name: 'newFormIndex',
      component: newFormIndex
    },
    {
      path: '/new_code',
      name: 'newCodePage',
      component: newCodePage
    },
    {
      path: '/new_list',
      name: 'newList',
      component: newList
    },

    // 普查
    {
      path: '/pucha',
      name: 'puchaFormIndex',
      component: puchaFormIndex
    },
      // pucha_eng
    {
      path: '/pucha_eng',
      name: 'puchaEngForm',
      component: puchaEngForm
    },
    {
      path: '/pucha_code',
      name: 'puchaCodePage',
      component: puchaCodePage
    },
    {
      path: '/pucha_list',
      name: 'puchaList',
      component: puchaList
    },

    // 石家庄
    {
      path: '/sjz_form',
      name: 'sjzFormIndex',
      component: sjzFormIndex
    },
    {
      path: '/sjz_code',
      name: 'sjzCodePage',
      component: sjzCodePage
    },
    {
      path: '/sjz_list',
      name: 'sjzList',
      component: sjzList
    },

    // 南科大
    {
      path: '/nkd',
      name: 'nkdForm',
      component: nkdForm,
      meta: {
        title: '核酸检测在线预约'
      }
    },
    {
      path: '/nkd_list',
      name: 'nkdList',
      component: nkdList,
      meta: {
        title: '历史预约信息'
      }
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
  ]
})


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js